import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "./App.css";
import { AuthProvider, useAuth } from "./context/AuthContext";
import WaterBackground from "./components/WaterBackground";
import AppShell from "./components/AppShell";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Entries from "./pages/Entries";
import BalanceSheet from "./pages/BalanceSheet";
import Backfill from "./pages/Backfill";
import Permissions from "./pages/Permissions";
import Admin from "./pages/Admin";
import Accounts from "./pages/Accounts";

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-400">
        Loading…
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return <AppShell>{children}</AppShell>;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center text-stone-400">
        Loading…
      </div>
    );
  }
  if (user) return <Navigate to="/" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route
        path="/login"
        element={
          <PublicOnly>
            <Login />
          </PublicOnly>
        }
      />
      <Route path="/signup" element={<Navigate to="/login" replace />} />
      <Route path="/" element={<Protected><Dashboard /></Protected>} />
      <Route path="/entries" element={<Protected><Entries /></Protected>} />
      <Route path="/accounts" element={<Protected><Accounts /></Protected>} />
      <Route path="/balance-sheet" element={<Protected><BalanceSheet /></Protected>} />
      <Route path="/backfill" element={<Protected><Backfill /></Protected>} />
      <Route path="/permissions" element={<Protected><Permissions /></Protected>} />
      <Route path="/admin" element={<Protected><Admin /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <>
      <WaterBackground />
      <div className="App">
        <AuthProvider>
          <BrowserRouter>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
        <Toaster position="top-center" toastOptions={{ className: "glass-strong rounded-2xl" }} />
      </div>
    </>
  );
}
